import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM11.14 14.88L8.65 12.7L9.64 11.57L11.08 12.83L14.34 9.6L15.39 10.67L11.14 14.88Z" fill={ fill || 'currentColor' } />
    </svg>
);
